import cn from 'classnames';
import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import styles from './VersionStatusBadge.module.scss';

export type VersionStatusBadgeStatus =
  | 'active'
  | 'draft'
  | 'archived'
  | 'deleted';

type VersionStatusBadgeProps = {
  status: VersionStatusBadgeStatus;
  className?: string;
};

const messages = defineMessages({
  active: {
    id: 'versionStatusBadge.current',
    defaultMessage: 'Active',
  },
  draft: {
    id: 'versionStatusBadge.draft',
    defaultMessage: 'Draft',
  },
  archived: {
    id: 'versionStatusBadge.archived',
    defaultMessage: 'Archived',
  },
  deleted: {
    id: 'versionStatusBadge.deleted',
    defaultMessage: 'Deleted',
  },
});

export const VersionStatusBadge: FC<VersionStatusBadgeProps> = (props) => {
  const { status, className } = props;
  const { formatMessage } = useIntl();

  return (
    <span className={cn(styles.container, styles[status], className)}>
      {formatMessage(messages[status])}
    </span>
  );
};
